import Table from 'react-bootstrap/Table'
import React, {useState} from 'react'
import Navbar from '../components/Notice/Navbar'
import Sidebar from '../components/Console/Sidebar'
// import {useTable} from 'react-table'
import '../App.css'
import ConsoleFooter from '../components/Console/Footer'
import {useTranslation} from "react-i18next"
import { Link } from 'react-router-dom';

function Text( ) {
  const {t} = useTranslation();
  const [isOpen, setIsOpen] = useState(false)

	const toggle = () => {
		setIsOpen(!isOpen)
	}
  // const {t} = useTranslation();
  // const [userList, setUserList] = useState([]);
  // const columns = [
  //   {dataField: "id", text:"Id"},
  //   {dataField: "name", text:"Name"},
  //   {dataField: "email", text:"Email"}
  // ]

  // useEffect(() => {
  //   fetch("https://jsonplaceholder.typicode.com/users")
  //   .then(response => response.json())
  //   .then(result => setUserList(result))
  //   .catch(error => console.log(error));
  // }, [])
  // useTable({
  //   columns: columns,
  //   data: userList
  // })
  return (
    <div>
      <Sidebar isOpen= {isOpen} toggle={toggle}/>
		  <Navbar />
      <div>
        <div style={{height:"fit-content", textAlign:"-webkit-center", marginTop:"150px"}}>
          <div className='textPage' style={{position:"relative", marginBottom:"50px"}}>
            <h1 style={{color:"#2783C6"}}>{t("issue")}</h1>
            <Table hover>
              <thead >
                
                <span style={{color:"black", float:"left", fontWeight:"500"}}>[사용자] 규제샌드박스 실증특례 고지</span>
                <span style={{color:"black", float: "right", fontWeight:"500"}}>2021-12-27</span>

              </thead>
              <tbody>
                <br/>
              <p style={{color:"black", textAlign:"center", fontWeight:"500"}}>[이용자 고지사항] “스마트 도전(盜電) 방지 콘센트” 실증특례</p>
              <p style={{textAlign:"right", marginTop:"10px"}}>레인써클</p>
                
                <div>
                <p style={{font:" normal  300 15px 'Spoqa Han Sans Neo'"}}>
                <b style={{fontSize:"17px"}}>01. 규제 특례의 대상인 서비스 명칭 및 내용</b><br />
                <p className='textPageText' style={{marginLeft:"30px"}}>- 명칭: OTP 방식을 이용한 스마트 도전방지 콘센트<br/>
                  - 주요 내용: 일회용 비밀번호(OTP: One Time Password) 입력으로 허가된 사용자만 콘센트를<br/>
                  사용할 수 있도록 하고 사용시간단위로 결제하여 집합건물 내 등 공개지의 유휴 콘센트를 공유 및 활용할 수 있게 하는 제품/서비스</p>
                  <b>02.  규제 특례 구역, 기간, 규모 (or 범위 등)</b><br/>
                    <p className='textPageText' style={{marginLeft:"30px"}}>- 유효 기간 : 2년 (책임 보험에 가입하고 사업 개시 확인서의 사업 개시일로 부터 2년)<br/>
                    - 구역 : 서울시. 제주도 지역 내 집합건물 지하주차장<br/>
                    - 규모 : 총 1,500개 이내</p>
                  
                  <b style={{fontSize:"17px"}}>03. 실증을 위한 규제 특례 법령 및 안전성 등을 확보하기 위해 붙인 조건</b><br/>
                    <p className='textPageText' style={{marginLeft:"30px", textIndent:""}}>
                      - 조건1. 제품의 안전성을 고려하여 콘센트용 KC 안전 인증을 받을 것<br/>
                      - 조건2. 기존 전력량단위 요금부과 방식과 가격이 차이날 수 있음을 안내하는 문구 등을 소비자에게 고지할 방안을 구축할 것<br/></p>
                  
                  <b style={{fontSize:"17px"}}>04. 책임보험 또는 손해에 대한 배상 방안의 내용</b><br/>
                      <p className='textPageText' style={{marginLeft:"30px"}}>- 생산물 배상 책임 보험 가입<br/>
                      <span className='textPageText' style={{marginLeft:"10px"}}># 보장한도 - 대인 1.8억/명, 대물: 10억원/사고당, 총 보상한도액 무제한 </span><br/>
                      - 개인정보보호 배상 책임 보험 가입<br/>
                      <span className='textPageText' style={{marginLeft:"10px"}}>#보장한도 - 1사고당 1억원, 총 보상한도 1억 </span><br/>
                        - 보험에서 보장하는 범위를 초과하는 손해에 대해서는 레인써클에서 전액 배상<br/></p>
                <b style={{fontSize:"17px"}}>05. 기타 장관이 제품. 서비스 이용과 관련하여 지정한 사항</b><br/>
                      <p className='textPageText' style={{marginLeft:"30px"}}>- 해당 사항 없음</p>
                </p>
                <p style={{textAlign:"right", marginBottom:"0"}}><b>담당자 : 정재웅 대표 (ceo@shareplug.co.kr)</b> </p>
                </div>
              </tbody>
              <tfoot>
                <td><b></b></td>
              </tfoot>
            </Table>
            <button className='noticeTextButton'><Link to="/notice" style={{textDecoration:"none"}}>{t("notice.btn")}</Link> </button>
          </div>
        </div>
      </div>
      <ConsoleFooter />
    </div>
  )
}

export default Text
